import { render, staticRenderFns } from "./fbDeviceUser.vue?vue&type=template&id=b96a3d6e&scoped=true"
import script from "./fbDeviceUser.vue?vue&type=script&lang=js"
export * from "./fbDeviceUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96a3d6e",
  null
  
)

export default component.exports